import { getSavedPostsAction } from "../redux/actions/postActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useCallback, useMemo } from "react";
import SavedPost from "../components/post/SavedPost";
// import NoSavedPost from "../assets/nopost.jpg";
import ContentWithCards from "../components/shared/ContentWithCards";
import LoadMoreButton from "../components/shared/LoadMoreButton";
import CommonLoading from "../components/loader/CommonLoading";

const Saved = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadMoreLoading, setIsLoadMoreLoading] = useState(false);
  
  const savedPosts = useSelector((state) => state.posts?.savedPosts);
  const totalSavedPosts = useSelector((state) => state.posts?.totalSavedPosts);
  
  const LIMIT = 10;

  useEffect(() => {
    const fetchSavedPosts = async () => {
      setIsLoading(true);
      await dispatch(getSavedPostsAction(LIMIT, 0));
      setIsLoading(false);
    };
    fetchSavedPosts();
  }, [dispatch, LIMIT]);

  const handleLoadMore = useCallback(() => {
    setIsLoadMoreLoading(true);
    const currentLength = savedPosts?.length || 0;
    dispatch(getSavedPostsAction(LIMIT, currentLength)).finally(() => {
      setIsLoadMoreLoading(false);
    });
  }, [dispatch, LIMIT, savedPosts?.length]);

  const memoizedPosts = useMemo(() => {
    return savedPosts?.map((post) => (
      <SavedPost key={post._id} post={post} />
    )) || [];
  }, [savedPosts]);

  if (isLoading) {
    return (
      <ContentWithCards>
        <div className="flex justify-center items-center py-8">
          <CommonLoading />
        </div>
      </ContentWithCards>
    );
  }

  return (
    <ContentWithCards>
      {savedPosts && savedPosts.length > 0 ? (
        <>
          <div className="w-full space-y-3 flex flex-col items-center max-w-3xl mx-auto overflow-visible">
            {memoizedPosts}
          </div>
          
          {/* Load More Button */}
          {savedPosts.length >= LIMIT && savedPosts.length < totalSavedPosts && (
            <LoadMoreButton
              onClick={handleLoadMore}
              isLoading={isLoadMoreLoading}
              text="Load More Saved Posts"
            />
          )}
        </>
      ) : (
        <div className="w-full bg-white border rounded-lg p-8 text-center max-w-3xl mx-auto">
          <h3 className="text-lg font-semibold text-gray-700 mb-2">No saved posts</h3>
          <p className="text-gray-500 mb-4 font-roboto-flex">You haven't saved any post yet.</p>
          {/* <img loading="lazy" src={NoSavedPost} alt="no post" className="mx-auto max-w-xs" /> */}
        </div>
      )}
    </ContentWithCards>
  );
};

export default Saved;
